<template>
	<PopupRouterView label="Reminder Input"  entityName="reminder" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="incomingDocuments" optionsLabel="documentCode" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Kode Risalah" id="input-" size="sm" :model.sync="model.incomingDocumentId"  :selected="model.incomingDocument != null ? model.incomingDocument.documentCode : ''" @input="getIncomingDocuments" />
				<app-input-datetimepicker  id="fieldset-reminder-date" label-cols-sm="4" label-cols-lg="3" label="Reminder Date" size="sm" :model.sync="model.reminderDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  />
				<app-input-combobox-autocomplete :options="reminderStatuss" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Reminder Status" id="input-" size="sm" :model.sync="model.reminderStatusId"  :selected="model.reminderStatus != null ? model.reminderStatus.name : ''" @input="getReminderStatuss" />
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Reminder from '@/models/Reminder/Reminder';
import ReminderList from '@/models/Reminder/ReminderList';
import ReminderFilter from '@/filters/Reminder/ReminderFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import IncomingDocument from '@/models/IncomingDocument/IncomingDocument';
import IncomingDocumentFilter from '@/filters/IncomingDocument/IncomingDocumentFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ReminderStatus from '@/models/ReminderStatus/ReminderStatus';
import ReminderStatusFilter from '@/filters/ReminderStatus/ReminderStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputComboboxAutocomplete,AppInputDatetimepicker,AppInputDatetimepickerRange,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterReminder : null,
			currentReminderPage : 1,
			reminderPageSize: 10,
			sortByReminder: '',
			sortDescReminder: '',
			incomingDocuments: [],
			reminderStatuss: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getReminder : async function(id) {
			this.isBusy = true;
			Reminder.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadReminder = true;
			this.filterReminder.id = this.modelId;
			Reminder.downloadDataDetail(this, this.filterReminder).then(result => {
				this.isDownloadReminder = false;
			}).catch(error => { this.isDownloadReminder = false; })
		},
		getIncomingDocuments : async function(input) {
			let filter = new IncomingDocumentFilter();
			if (input != undefined) {
				filter.documentCode = input;
			}
			IncomingDocument.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.incomingDocuments = result.data
				}
			})
			.catch(error => {});
		},
		getReminderStatuss : async function(input) {
			let filter = new ReminderStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ReminderStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.reminderStatuss = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					Reminder.updateData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'reminderindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
			} else {
				Reminder.insertData(this, model).then(result => {
					this.$router.push({ name: 'reminderindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
			}
		},
		onHidden() {
			this.getReminders();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterReminder = new ReminderFilter();
		this.getIncomingDocuments();
		this.getReminderStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getReminder(id);
			} else {
				this.modelId = id;
				this.getReminder(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
